module.exports = __webpack_public_path__ + "media/application/images/2018/2018-logo-f935f413e2f17d208bbb521d0498a0c3.svg";